import React from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'

const BannedComponent = ({ t }) => (
  <div>
    <img
      alt='rateau illustration'
      className='img--centered img--rounded'
      src='/app/images/rateau.png' />
    <p className='paragraph--centered'>
      { `${t('common:account:blocked')}` }
    </p>
    <p className='paragraph--centered'>
      {t('common:jardiniers:empty_message_call_us')}.
    </p>
  </div>
)

BannedComponent.propTypes = {
  t: func
}

export const Banned = translate()(BannedComponent)



// WEBPACK FOOTER //
// ./src/components/ui/states/Banned.js